module.exports = __webpack_public_path__ + "img/ManekiWaveFish.3399d1c8.png";